import { axiosRequestHelper, RequestHelperResult } from './endpoint-helpers';

export const removeTeamFromApplication = (id: string, teamId: string): Promise<RequestHelperResult<undefined>> =>
    axiosRequestHelper('DELETE', `/api/applications/${id}/teams/${teamId}`);
